import axios from 'axios'

import environment from '../environments/environment'

/**
 * Log de inicio de entrega
 * @param {*} order_id 
 * @param {*} type ripley o mirakl 
 */
const entregaInit = async (order_id) => {

    const { data } = await axios.post(`${environment.api.host}/oc/entrega/init`, {
       id: order_id
    })
    
    return data;

}


/**
 * Validación de entrega completada
 * @param {*} order_id 
 */
const entregaEnd = async (order_id) => {

    const { data } = await axios.post(`${environment.api.host}/oc/entrega/end`, {
       id: order_id
    })
    
    return data;

}

const OrderService = {
    entregaInit,
    entregaEnd
}

export default OrderService